import {
  TypeContratAvenantLibelles,
  DiplomeLibelle,
  ModalitePedagogiqueLibelle,
  ModaliteFacturationLibelle,
  TypeSalaireLibelle,
  TypeReferentielFormationLibelle,
  NatureContratLibelle,
} from '@/features/domaine/types/opco/Demande/CPRO/index'
import { objectToDropdownItems } from '@/features/interface/shared/tools'

export const diplomeItems = objectToDropdownItems(DiplomeLibelle)
export const modalitePedagogiqueItems = objectToDropdownItems(ModalitePedagogiqueLibelle)
export const ModaliteFacturationItems = objectToDropdownItems(ModaliteFacturationLibelle)
export const typeContratAvenantItems = objectToDropdownItems(TypeContratAvenantLibelles)
export const typeSalaireItems = objectToDropdownItems(TypeSalaireLibelle)
export const typeReferentielFormationItems = objectToDropdownItems(TypeReferentielFormationLibelle)
export const natureContratItems = objectToDropdownItems(NatureContratLibelle)
